module.exports = __webpack_public_path__ + "img/forest-tfidf.0aa201ea.png";